import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { Documents } from "@/components/portal/Documents";
import { MyAgreements } from "@/components/portal/MyAgreements";
import { MyConsultations } from "@/components/portal/MyConsultations";
import { SavedGrants } from "@/components/portal/SavedGrants";

export default function Dashboard() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    useEffect(() => { if (!loading && !user) navigate("/"); }, [loading, user, navigate]);
    if (loading || !user) return <div className="flex min-h-screen items-center justify-center bg-slate-50"><Loader2 className="h-6 w-6 animate-spin text-teal" /></div>;

    return (
        <div className="min-h-screen bg-[#F6F9FD]">
            <Header />
            <main className="mx-auto max-w-6xl px-4 pt-28 pb-20 lg:px-8">
                <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
                    <div>
                        <div className="section-label mb-2">Client portal</div>
                        <h1 className="font-heading text-3xl font-bold text-navy sm:text-4xl">Welcome, {user.name?.split(" ")[0] || "there"}</h1>
                        <p className="mt-2 text-slate-500">Your consultations, documents, agreements, and saved funding — all in one place.</p>
                    </div>
                    <Link to="/services" data-testid="portal-browse-services" className="rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-ocean">Browse services</Link>
                </div>
                <Tabs defaultValue="consultations">
                    <TabsList className="mb-8 flex-wrap rounded-full border border-slate-200 bg-white p-1 shadow-sm">
                        <TabsTrigger value="consultations" data-testid="tab-consultations" className="data-[state=active]:bg-navy data-[state=active]:text-white">Consultations</TabsTrigger>
                        <TabsTrigger value="documents" data-testid="tab-documents" className="data-[state=active]:bg-navy data-[state=active]:text-white">My Documents</TabsTrigger>
                        <TabsTrigger value="agreements" data-testid="tab-agreements" className="data-[state=active]:bg-navy data-[state=active]:text-white">My Agreements</TabsTrigger>
                        <TabsTrigger value="grants" data-testid="tab-grants" className="data-[state=active]:bg-navy data-[state=active]:text-white">Smarter Grants</TabsTrigger>
                    </TabsList>
                    <TabsContent value="consultations"><MyConsultations /></TabsContent>
                    <TabsContent value="documents"><Documents /></TabsContent>
                    <TabsContent value="agreements"><MyAgreements /></TabsContent>
                    <TabsContent value="grants"><SavedGrants /></TabsContent>
                </Tabs>
            </main>
        </div>
    );
}
